import React from 'react';
import { Col, ContactFieldManager, CountrySelect, FMGModal, Form, Input, Row, Select, Typography } from 'components';
import { ValidationErrors } from 'constants/validations';
import { useAddClient } from './useAddClient';

const { Item } = Form;
const { TextArea } = Input;

interface IAddClient {
  modalState: boolean;
  closeModal: () => void;
}

export const AddClient = (props: IAddClient) => {
  const { modalState, closeModal } = props;
  const {
    form,
    contextHolder,
    disableSaveBtn,
    isLoading,
    languageData,
    clientTypeData,
    onClientAdd,
    onValuesChange,
    onCancel,
  } = useAddClient({
    closeModal,
  });
  return (
    <>
      {contextHolder}
      <FMGModal
        title={'Add Client'}
        okText={'Add'}
        open={modalState}
        disableOkBtn={disableSaveBtn}
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={onClientAdd}
      >
        <Form
          onValuesChange={onValuesChange}
          form={form}
          layout={'vertical'}
          requiredMark={false}
          className={'margin-t-20'}
        >
          <Row justify={'space-between'} gutter={[16, 20]}>
            <Col span={12}>
              <Item
                label={'Client Name*'}
                name={'name'}
                rules={[
                  {
                    required: true,
                    message: ValidationErrors.required('Client Name'),
                  },
                ]}
              >
                <Input size={'large'} />
              </Item>
            </Col>
            <Col span={12}>
              <Item
                label={'Client Type*'}
                name={'clientTypeId'}
                rules={[
                  {
                    required: true,
                    message: ValidationErrors.required('Client Type'),
                  },
                ]}
              >
                <Select
                  options={clientTypeData}
                  size={'large'}
                  showSearch
                  filterOption={(input, option) => {
                    if (option) {
                      const label: string = option.label?.toString() || '';
                      return label?.toLowerCase()?.includes(input?.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Item>
            </Col>
            <Col span={12}>
              <Item
                label={'Main Country*'}
                name={'mainCountryId'}
                rules={[
                  {
                    required: true,
                    message: ValidationErrors.required('Main Country'),
                  },
                ]}
              >
                <CountrySelect size={'large'} />
              </Item>
            </Col>
            <Col span={24}>
              <Item label={'Additional Notes'} name={'additionalNotes'}>
                <TextArea rows={4} />
              </Item>
            </Col>
            <Col span={24}>
              <Typography.Text style={{ color: '#05796B', fontWeight: 800 }}>Contact Person</Typography.Text>
            </Col>
            <Col span={12}>
              <Item label={'Full Name'} name={'fullName'}>
                <Input size={'large'} />
              </Item>
            </Col>
            <Col span={12}>
              <Item label={'Language'} name={'languageId'}>
                <Select
                  options={languageData}
                  size={'large'}
                  showSearch
                  filterOption={(input, option) => {
                    if (option) {
                      const label: string = option.label?.toString() || '';
                      return label?.toLowerCase()?.includes(input?.toLowerCase());
                    }
                    return false;
                  }}
                />
              </Item>
            </Col>
            <Col span={12}>
              <Item label={'Department'} name={'department'}>
                <Input size={'large'} />
              </Item>
            </Col>
            <Col span={12}>
              <Item label={'Role'} name={'role'}>
                <Input size={'large'} />
              </Item>
            </Col>
            <Col span={24}>
              <ContactFieldManager modalState={modalState} form={form} />
            </Col>
          </Row>
        </Form>
      </FMGModal>
    </>
  );
};
